import { createFileRoute } from '@tanstack/react-router'

import { DatasetDetailPage } from '#/modules/ai/back-office/dataset-detail-page/dataset-detail-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/evaluations/$workflowId/datasets/$datasetId')({
  beforeLoad: (options) => requirePermissions(options, ['aiAnalysis.dataset.read']),
  component: function Component() {
    const { workflowId, datasetId } = Route.useParams()
    return <DatasetDetailPage workflowId={workflowId} datasetId={datasetId} />
  },
})
